import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _de00315c = () => interopDefault(import('../pages/in/index.vue' /* webpackChunkName: "pages/in/index" */))
const _5fba350d = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _a99d7e26 = () => interopDefault(import('../pages/whitepaper.vue' /* webpackChunkName: "pages/whitepaper" */))
const _71480c8d = () => interopDefault(import('../pages/in/about.vue' /* webpackChunkName: "pages/in/about" */))
const _1056b03b = () => interopDefault(import('../pages/in/getapp.vue' /* webpackChunkName: "pages/in/getapp" */))
const _7ccc7e3d = () => interopDefault(import('../pages/in/logout/index.vue' /* webpackChunkName: "pages/in/logout/index" */))
const _0d17484c = () => interopDefault(import('../pages/in/oauth/index.vue' /* webpackChunkName: "pages/in/oauth/index" */))
const _584e96fa = () => interopDefault(import('../pages/in/policies/index.vue' /* webpackChunkName: "pages/in/policies/index" */))
const _d1ccb3d4 = () => interopDefault(import('../pages/in/register/index.vue' /* webpackChunkName: "pages/in/register/index" */))
const _5a4e515a = () => interopDefault(import('../pages/in/settings.vue' /* webpackChunkName: "pages/in/settings" */))
const _31e558d4 = () => interopDefault(import('../pages/in/settings/index.vue' /* webpackChunkName: "pages/in/settings/index" */))
const _33d835c4 = () => interopDefault(import('../pages/in/settings/button.vue' /* webpackChunkName: "pages/in/settings/button" */))
const _7238be62 = () => interopDefault(import('../pages/in/settings/others.vue' /* webpackChunkName: "pages/in/settings/others" */))
const _2549fc33 = () => interopDefault(import('../pages/in/whitepaper.vue' /* webpackChunkName: "pages/in/whitepaper" */))
const _e17e18ae = () => interopDefault(import('../pages/in/matters/redirect.vue' /* webpackChunkName: "pages/in/matters/redirect" */))
const _ee0b7c0e = () => interopDefault(import('../pages/in/policies/privacy.vue' /* webpackChunkName: "pages/in/policies/privacy" */))
const _7dd672b8 = () => interopDefault(import('../pages/in/policies/terms.vue' /* webpackChunkName: "pages/in/policies/terms" */))
const _701ee4d1 = () => interopDefault(import('../pages/in/widget/iscn-ar/index.vue' /* webpackChunkName: "pages/in/widget/iscn-ar/index" */))
const _b362d160 = () => interopDefault(import('../pages/in/widget/pay/index.vue' /* webpackChunkName: "pages/in/widget/pay/index" */))
const _1415b88a = () => interopDefault(import('../pages/in/widget/authcore/seedwords.vue' /* webpackChunkName: "pages/in/widget/authcore/seedwords" */))
const _0197d458 = () => interopDefault(import('../pages/in/widget/user/delete.vue' /* webpackChunkName: "pages/in/widget/user/delete" */))
const _19da593e = () => interopDefault(import('../pages/in/widget/authcore/desmos/proof.vue' /* webpackChunkName: "pages/in/widget/authcore/desmos/proof" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _9bf37da4 = () => interopDefault(import('../pages/in/tx/iscn/_id/index.vue' /* webpackChunkName: "pages/in/tx/iscn/_id/index" */))
const _37419e87 = () => interopDefault(import('../pages/in/embed/_id/index.vue' /* webpackChunkName: "pages/in/embed/_id/index" */))
const _92828bbc = () => interopDefault(import('../pages/in/tx/_id/index.vue' /* webpackChunkName: "pages/in/tx/_id/index" */))
const _c72e0f66 = () => interopDefault(import('../pages/in/embed/_id/button.vue' /* webpackChunkName: "pages/in/embed/_id/button" */))
const _5fe7b85c = () => interopDefault(import('../pages/tx/_id/index.vue' /* webpackChunkName: "pages/tx/_id/index" */))
const _3bcfac71 = () => interopDefault(import('../pages/verify/_uuid/index.vue' /* webpackChunkName: "pages/verify/_uuid/index" */))
const _6a314543 = () => interopDefault(import('../pages/_id/index.vue' /* webpackChunkName: "pages/_id/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/in",
    component: _de00315c,
    name: "in"
  }, {
    path: "/register",
    component: _5fba350d,
    name: "register"
  }, {
    path: "/whitepaper",
    component: _a99d7e26,
    name: "whitepaper"
  }, {
    path: "/in/about",
    component: _71480c8d,
    name: "in-about"
  }, {
    path: "/in/getapp",
    component: _1056b03b,
    name: "in-getapp"
  }, {
    path: "/in/logout",
    component: _7ccc7e3d,
    name: "in-logout"
  }, {
    path: "/in/oauth",
    component: _0d17484c,
    name: "in-oauth"
  }, {
    path: "/in/policies",
    component: _584e96fa,
    name: "in-policies"
  }, {
    path: "/in/register",
    component: _d1ccb3d4,
    name: "in-register"
  }, {
    path: "/in/settings",
    component: _5a4e515a,
    children: [{
      path: "",
      component: _31e558d4,
      name: "in-settings"
    }, {
      path: "button",
      component: _33d835c4,
      name: "in-settings-button"
    }, {
      path: "others",
      component: _7238be62,
      name: "in-settings-others"
    }]
  }, {
    path: "/in/whitepaper",
    component: _2549fc33,
    name: "in-whitepaper"
  }, {
    path: "/in/matters/redirect",
    component: _e17e18ae,
    name: "in-matters-redirect"
  }, {
    path: "/in/policies/privacy",
    component: _ee0b7c0e,
    name: "in-policies-privacy"
  }, {
    path: "/in/policies/terms",
    component: _7dd672b8,
    name: "in-policies-terms"
  }, {
    path: "/in/widget/iscn-ar",
    component: _701ee4d1,
    name: "in-widget-iscn-ar"
  }, {
    path: "/in/widget/pay",
    component: _b362d160,
    name: "in-widget-pay"
  }, {
    path: "/in/widget/authcore/seedwords",
    component: _1415b88a,
    name: "in-widget-authcore-seedwords"
  }, {
    path: "/in/widget/user/delete",
    component: _0197d458,
    name: "in-widget-user-delete"
  }, {
    path: "/in/widget/authcore/desmos/proof",
    component: _19da593e,
    name: "in-widget-authcore-desmos-proof"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/in/tx/iscn/:id",
    component: _9bf37da4,
    name: "in-tx-iscn-id"
  }, {
    path: "/in/embed/:id",
    component: _37419e87,
    name: "in-embed-id"
  }, {
    path: "/in/tx/:id",
    component: _92828bbc,
    name: "in-tx-id"
  }, {
    path: "/in/embed/:id?/button",
    component: _c72e0f66,
    name: "in-embed-id-button"
  }, {
    path: "/tx/:id",
    component: _5fe7b85c,
    name: "tx-id"
  }, {
    path: "/verify/:uuid",
    component: _3bcfac71,
    name: "verify-uuid"
  }, {
    path: "/:id",
    component: _6a314543,
    name: "id"
  }, {
    path: "/verify/:uuid/:coupon",
    component: _3bcfac71,
    name: "verify-uuid-coupon"
  }, {
    path: "/:id/:amount?",
    component: _6a314543,
    name: "id-amount"
  }, {
    path: "/in/embed/:id/:amount?",
    component: _37419e87,
    name: "in-embed-id-amount"
  }, {
    path: "/in/embed/:id/button/:amount?",
    component: _c72e0f66,
    name: "in-embed-id-button-amount"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
